import { useEffect, useState } from "react"
import { PackageCard } from "../package-card"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"
import { ChevronRight } from "lucide-react"

export default function Healthcheckupspackageswidget() {

  const [data, setData] = useState(null)

  useEffect(() => {
    fetch("/wp-json/custom/v1/packages")
      .then(res => res.json())
      .then(res => setData(res))
  }, [])

  if (!data) return null

  return (
    <section className="py-12 bg-white">
      <div className="container px-4 mx-auto">

        <div className="flex flex-col items-center mb-10 text-center">
          <Badge className="mb-2">Health Packages</Badge>

          <h2 className="mb-4 text-3xl font-bold md:text-4xl">
            {data.title}
          </h2>

          <p className="max-w-2xl text-muted-foreground">
            {data.description}
          </p>
        </div>

        <div className="relative">

          {/* Offer badge */}
          {data.offer_text && (
            <div className="absolute -top-4 right-4 md:right-8 z-10">
              <Badge className="bg-primary text-white">
                {data.offer_text}
              </Badge>
            </div>
          )}

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">

            {data.items?.map((item, index) => (
              <PackageCard
                key={index}
                title={item.title}
                price={item.price}
                description={item.description}
                tests={item.tests?.map(t => t.name) || []}
                featured={item.featured}
                href={item.link}
              />
            ))}

          </div>
        </div>

        <div className="flex justify-center mt-8">
          <Button className="gap-2" asChild>
            <a href={data.button_link}>
              {data.button_text || "View All Packages"}
              <ChevronRight className="w-4 h-4" />
            </a>
          </Button>
        </div>

      </div>
    </section>
  )
}